/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PolygonImportResult } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PolygonImportClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
 * No description
 * 
 * @tags PolygonImport
 * @summary Парсинг файлов разных форматов и сохранение полигонов в БД с привязкой к заданному проекту.
Название каждого полигона устанавливается в имя файла без расширения.
 * @request POST:/geofile-import/polygons/files/to_project/{projectId}
 * @secure
 */
  polygonImportAddPolygonsFromFilesToProject = (
    projectId: string,
    data: {
      /** список файлов для импорта полигонов */
      fileCollection: File[]
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PolygonImportResult[], any>({
      path: `/geofile-import/polygons/files/to_project/${projectId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })
}
